<span
  class="inline-loader"
  [ngClass]="{
    sm: size() == 'sm',
    lg: size() == 'lg',
    md: size() == 'md',
    light: color() == 'light',
    primary: color() == 'primary'
  }"
  aria-hidden="true"
></span>
